var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrivalTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_102161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 9.81676V14.7751C5 15.0021 5.15284 15.2005 5.37224 15.2585L13.75 17.4727L24.4827 20.3235C25.2933 20.5389 26.2921 20.4914 26.6507 19.7331C26.9373 19.127 26.811 18.4692 26.5067 17.9662C26.2164 17.4864 25.6631 17.2674 25.1249 17.11L19.5719 15.486C19.41 15.4387 19.2829 15.3129 19.2339 15.1516L16.1431 4.98761C16.0929 4.82277 15.9615 4.69535 15.7952 4.6504L14.3805 4.26805C14.0626 4.18215 13.75 4.42152 13.75 4.75073V13.2616C13.75 13.5894 13.4398 13.8285 13.1228 13.7451L8.06339 12.4137C7.90609 12.3723 7.77875 12.257 7.72203 12.1045L6.90167 9.89979C6.84567 9.7493 6.72081 9.63486 6.56602 9.59216L5.63296 9.33477C5.31457 9.24693 5 9.48647 5 9.81676Z",
    fill: "#1B2646",
    stroke: "#1B2646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75 26.7852H27.25",
    stroke: "#1B2646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_102161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivalTime);
export default __webpack_public_path__ + "static/media/arrival-time.cd9ceebbb73d2460b356ccf255045d2c.svg";
export { ForwardRef as ReactComponent };